<div nimbusTheme>
  <div
    class="nimbus-modal"
    [ngClass]="{
      'nimbus-modal-info': alertType === AlertType.Information,
      'nimbus-modal-warning': alertType === AlertType.Warning,
      'nimbus-modal-error': alertType === AlertType.Error,
      'nimbus-modal-success': alertType === AlertType.Success,
      'nimbus-modal-validation': alertType === AlertType.Validation,
    }"
  >
    <div class="nimbus-modal-header">
      <div class="nimbus-modal-header-title">
        <ng-content select="header"> </ng-content>
      </div>
      <div class="nimbus-modal-header-controls"></div>
    </div>
    <div class="nimbus-modal-body" cdk-scrollable>
      <ng-content select="body"> </ng-content>
    </div>
    @if (!hideFooter) {
      <div class="nimbus-modal-footer flex-container flex-align-center-right">
        <ng-content select="footer"> </ng-content>
      </div>
    }
  </div>
</div>
